import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {price} from "./filter_slot_presets/price";
import {propertyType} from "./filter_slot_presets/property_type";
import {rooms} from "./filter_slot_presets/rooms";

export const notificationFilters: ISearchFilters<ISearchFiltersFormValues> = {
    slots: [propertyType, price, rooms]
};
import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {price} from "./filter_slot_presets/price";
import {propertyType} from "./filter_slot_presets/property_type";
import {rooms} from "./filter_slot_presets/rooms";

export const notificationFilters: ISearchFilters<ISearchFiltersFormValues> = {
    slots: [propertyType, price, rooms]
};
